$(document).ready(function () {
    //show the selection modal when the button is clicked
    $(document).on('click', '#orderType', function () {
        modalShowId('#orderTypeModal');
    });

    $(".delivery-locator-menu").hide();
    if ( orderViewModel.hasDeliveryLocator) {
        $(".delivery-locator-menu").show();
        $(".Locator-bar").hide();
    }
 
});

$(document).on('click', '#shopMenu', function () {
    if (orderViewModel.cartProducts.length === 0 && orderViewModel.store.id === null) {
        window.location.href = subwayScript.navigation.getLocatorUrl();
    }
    else {
        window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
    }
});